import React, { useMemo } from 'react'
import styles from "./DigitalPortrait.module.css";
import moment from 'moment';
import {Radar} from './radar/Radar'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
    RadialLinearScale
} from 'chart.js';
import { Line, Bar } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
    RadialLinearScale
);

const DigitalPortrait = ({ data, schemaType, isRadial, isCompare, ratingCalc, mid, minMaxRating, loadingRadar, 
    width='600px', height='300px', wrapLineMargin='2rem 0 2rem',
    compareMargin='2rem 0'
    }) => {
        
        const options = {
        responsive: false,
        maintainAspectRatio: false,

        plugins: {
            title: {
                color: "rgba(0, 0, 0, 1)",
                display: true,
                text: `Цифровой портрет ${!isCompare && data && data[0]?.lastname || ''} ${!isCompare && data && data[0]?.firstname?.split('')[0] || ''}.${!isCompare && data && data[0]?.patronymic?.split('')[0] || ''}.`
            },
            tooltip: {
                mode: "index",
                intersect: false,
                caretSize: 3,
            },
            legend: {
                labels: {
                    color: "rgba(0, 0, 0, 1)",
                },
            },
        },
        scales: {
            xAxes: {
                ticks: {
                    color: 'rgba(0, 0, 0, 1)', 
                }
            },
            yAxes: {
                ticks: {
                    color: 'rgba(0, 0, 0, 1)', 
                    beginAtZero: true,
                    stepSize: 0.25
                }
            }
        }
    };
    const options2 = {
        responsive: false,
        maintainAspectRatio: false,
        plugins: {
            title: {
                color: "rgba(0, 0, 0, 1)",
                display: true,
                text: `Диаграмма ${!isCompare && data && data[0]?.lastname || ''} ${!isCompare && data && data[0]?.firstname?.split('')[0] || ''}.${!isCompare && data && data[0]?.patronymic?.split('')[0] || ''}.`
            },
            legend: {
                labels: {
                    color: "rgba(0, 0, 0, 1)",
                },
            },
        },
        scales: {
            xAxes: {
                ticks: {
                    color: 'rgba(0, 0, 0, 1)', 
                }
            },
            yAxes: {
                ticks: {
                    color: 'rgba(0, 0, 0, 1)', 
                    beginAtZero: true,
                }
            }
        }
    };

    const options3 = {
        responsive: false,
        maintainAspectRatio: false,
        plugins: {
            title: {
                color: "rgba(0, 0, 0, 1)",
                display: true,
                text: `Сравнительная диаграмма`
            },
            legend: {
                labels: {
                    color: "rgba(0, 0, 0, 1)",
                },
            },
        },
        scales: {
            xAxes: {
                ticks: {
                    color: 'rgba(0, 0, 0, 1)', 
                }
            },
            yAxes: {
                ticks: {
                    color: 'rgba(0, 0, 0, 1)', 
                    beginAtZero: true,
                    stepSize: 0.25
                }
            }
        }
    };

const groups = useMemo(() => {
    if(data && data.length){
      // Проверяем новую структуру (schemaType + diagrems=1)
      if (data[0]?.first_level_id && data[0]?.user_results) {
        // Новая структура: [{ first_level_title, first_level_id, user_results: [...] }, ...]
        // Преобразуем в формат для сравнительной диаграммы
        return data.map(category =>
          category.user_results?.map(user => ({
            id: category.first_level_id,
            title: category.first_level_title,
            lastname: user.lastname,
            firstname: user.firstname,
            patronymic: user.patronymic,
            points: user.last_level_points || 0,
            mid: user.mid
          })) || []
        );
      }

      // Старая структура
      const tmp = {}

      for(const line of data){
        if(tmp[line.id]){
          tmp[line.id].push(line)
        } else {
          tmp[line.id] = [line]
        }
      }

      return [...Object.values(tmp)]
    }

    return []
  }, [data])

const lines = useMemo(() => {
    if (data && data?.length && !isCompare) {
        // Новая структура: берем данные выбранного пользователя
        if (data[0]?.first_level_id && data[0]?.user_results) {
            if (!mid) return [];
            const userLines = data
                .map((category, idx) => {
                    const user = category.user_results?.find(u => u.mid === mid);
                    if (!user) return null;
                    return [{
                        title: category.first_level_title,
                        alias: category.first_level_title,
                        points: user.last_level_points || 0,
                        color: colors[idx % colors.length]
                    }];
                })
                .filter(Boolean);
            return userLines;
        }

        // Старая структура
        const tmp = {}

        for (const line of data) {
            // Используем title или alias
            const key = line.title || line.alias;
            if (key) {
                if (tmp[key]) {
                    tmp[key].push(line)
                } else {
                    tmp[key] = [line]
                }
            }
        }

        return [...Object.values(tmp)]
    }

    return []
}, [data, isCompare, mid])

const colors = [
    'rgba(0, 255, 255, 1)',
    'rgba(226, 20, 37, 1)',
    'rgba(39, 116, 175, 1)',
    'rgba(17, 142, 92, 1)',
    'rgba(241, 139, 36, 1)',
    'rgba(107, 60, 138, 1)',
]

const dats = useMemo(() => {
    if (!lines?.length) {
        return [];
    }

    return lines.map((line, index) => ({
        label: line[0]?.title || line[0]?.alias,
        data: line.map((el => parseFloat(el.points) || 0)),
        backgroundColor: colors[index],
        borderColor: colors[index],
    }));
}, [lines])

const getData = (val) => {
    if (val) {
        return moment(val).format('MMMM') 
    } else {
        return ''
    }
}
const datas = useMemo(() => {
    // Новая структура: отображаем бар по категориям пользователя
    if (data && data[0]?.first_level_id && data[0]?.user_results && !isCompare) {
        const labels = lines.map(line => line[0]?.title || line[0]?.alias);
        const dataset = [{
            label: 'Показатели',
            data: lines.map(line => parseFloat(line[0]?.points) || 0),
            backgroundColor: labels.map((_, idx) => colors[idx % colors.length]),
            borderColor: labels.map((_, idx) => colors[idx % colors.length]),
        }];
        return { labels, datasets: dataset };
    }

    return {
        labels: lines?.[1]?.map(el => `${getData(el?.periodend)}`) || [],
        datasets: dats
    };
}, [data, lines, dats, isCompare])

const datas2 = (els, indexs) => {
    return {
        labels: els?.map((el) => {
            // Если есть periodend - показываем месяц, иначе показываем title/alias
            if (el?.periodend) {
                return moment(el.periodend).format('MMMM');
            }
            return el?.title || el?.alias || '';
        }) || [],
        datasets: dats2(els, indexs)
    }
};

const dats2 = (els, index) => (!els?.length ? [] : [{
    label: els[0]?.title || els[0]?.alias,
    data: els.map((el) => parseFloat(el?.points) || 0),
    backgroundColor: colors[index],
}]);

const datas3 = (group, indexs) => {
    return {
        labels: group?.length ? group.map((el) => {
            const firstname = el?.firstname || '';
            const patronymic = el?.patronymic || '';
            return `${el?.lastname || ''} ${firstname.split('')[0] || ''}.${patronymic.split('')[0] || ''}.`;
        }) : [],
        datasets: dats3(group, indexs)
    }
};

const dats3 = (group, index) => (!group?.length ? [] : [{
    label: group[0]?.title,
    data: group.map((el) => parseFloat(el?.points) || 0),
    backgroundColor: colors[index],
}]);

    return (
        <>
            {!schemaType && !isCompare && data && data?.length && datas.datasets?.length > 0 && !isRadial ?
                <div className={styles.line}>
                    {/* Новая структура — бар по категориям, старая — линия */}
                    {data[0]?.first_level_id && data[0]?.user_results
                        ? <Bar options={options2} data={datas} width={width} height={height} />
                        : <Line options={options} data={datas} width={width} height={height} />
                    }
                </div>
                :
                schemaType && !isCompare && data && data?.length ?
                <div className={styles.wrapLine} style={{margin: wrapLineMargin}}>
                    {lines && lines?.length && lines.map((els, index) => els?.length > 0 &&
                        <div className={styles.bar} key={index}>
                            <Bar options={options2} data={datas2(els, index)} width="400px" height="250px" />
                        </div>
                    )}
                </div>
                :
                ''
            }

            {!schemaType && !isCompare && isRadial && ratingCalc && !loadingRadar &&
                <div className={styles.radar}>
                    <Radar 
                        data={ratingCalc}
                        minMax={minMaxRating}
                        mid={mid}
                        imageUrl='https://media-exp1.licdn.com/dms/image/C560BAQH9Cnv1weU07g/company-logo_200_200/0/1575479070098?e=2147483647&v=beta&t=i4Pp6zVfz5VAznPIik_ua4I75sKlu4yAdGKgHC9vpTo'
                        style={{
                            margin: '0 auto',
                            display: 'flex',
                            justifyContent: 'center',
                            width: '650px',
                        }}
                        />
                </div>
            }

            {
                isCompare && groups && groups.length &&
                    <div className={styles.wrapLine}>
                        {
                            groups.map((group, index) => 
                                <div className={styles.compare} style={{margin: compareMargin}} width={width} height={height} key={index}>
                                    <Bar options={options3} data={datas3(group, index)} width={width} height={height} />
                                </div>    
                            )
                        }
                    </div>
            }
        </>
    )
}

export default DigitalPortrait
